const BASE = import.meta.env.VITE_API_URL || '';

interface AuthState {
  token: string | null;
  email: string | null;
}

let state: AuthState = {
  token: localStorage.getItem('vyradash_token'),
  email: localStorage.getItem('vyradash_email'),
};

const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((fn) => fn());
}

export function getToken(): string | null {
  return state.token;
}

export function getEmail(): string | null {
  return state.email;
}

export function isAuthenticated(): boolean {
  return !!state.token;
}

export function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export async function login(email: string, password: string): Promise<void> {
  const res = await fetch(`${BASE}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: 'Login failed' }));
    throw new Error(body.error || 'Login failed');
  }

  const data = await res.json();
  state = { token: data.data.token, email: data.data.email };
  localStorage.setItem('vyradash_token', data.data.token);
  localStorage.setItem('vyradash_email', data.data.email);
  notify();
}

export function logout(): void {
  state = { token: null, email: null };
  localStorage.removeItem('vyradash_token');
  localStorage.removeItem('vyradash_email');
  fetch(`${BASE}/api/auth/logout`, {
    method: 'POST',
    credentials: 'include',
  }).catch(() => {});
  notify();
}

export async function checkSession(): Promise<boolean> {
  if (!state.token) return false;
  try {
    const res = await fetch(`${BASE}/api/auth/check`, {
      headers: { Authorization: `Bearer ${state.token}` },
      credentials: 'include',
    });
    if (!res.ok) {
      logout();
      return false;
    }
    return true;
  } catch {
    logout();
    return false;
  }
}
